import React, { useState, useEffect, useRef } from "react";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
import { Helmet } from "react-helmet";
import { FaPlus, FaTrashAlt, FaTimes } from "react-icons/fa";
import "./assignment-reservation.css";
import Swal from "sweetalert2";
import axios from "axios";
import { FaPencil } from "react-icons/fa6";
import { createRoot } from "react-dom/client";
import { PiAirplaneTiltFill } from "react-icons/pi";

function AssignmentReservation({ onSuccess, masterData }) {
  const tbodyRef = useRef();
  const [rows, setRows] = useState(masterData.data.view_reser);
  // const [rows, setRows] = useState([]);
  const [alerts, setAlerts] = useState([]);
  const [errors, setErrors] = useState([]);
  const [showHouses, setShowHouses] = useState(false);

  const totalPiezasGuia = parseFloat(masterData.data.resp.pieces);
  const totalPesoGuia = parseFloat(masterData.data.resp.weight);

  const yearOptions = Array.from(
    { length: new Date().getFullYear() + 1 - 2019 + 1 },
    (_, i) => 2019 + i
  );

  const formatFlight = (value) => {
    let raw = value.toUpperCase().replace(/[^A-Z0-9/]/g, "");

    // Solo formatear si coincide con todo el patrón
    let match = raw.match(/^AM(\d{1,4})\/(\d{1,2})([A-Z]{3})$/);
    if (!match) return raw; // no formatear si está incompleto

    let number = match[1].padStart(4, "0");
    let day = match[2].padStart(2, "0");
    let month = match[3]; // sin padEnd ni guiones

    return `AM${number}/${day}${month}`;
  };

  const isValidPeso = (valor) => {
    const regex = /^\d+(\.\d{1,4})?$/;
    return regex.test(valor);
  };

  const isValidPiezas = (valor) => {
    const regex = /^\d+$/;
    return regex.test(valor);
  };

  const formatVuelo = (value) => {
    const upperValue = value.toUpperCase().replace(/\s/g, "");

    // Caso completo correcto
    const fullMatch = upperValue.match(
      /^([A-Z]{2})(\d{1,4})\/(\d{2})([A-Z]{3})$/i
    );
    if (fullMatch) {
      const [, airline, number, day, month] = fullMatch;
      return `${airline}${number.padStart(4, "0")}/${day}${month}`;
    }

    // Si tiene 6 caracteres iniciales sin la diagonal
    const partialMatch = upperValue.match(/^([A-Z]{2})(\d{1,4})$/);
    if (partialMatch && upperValue.length === 6) {
      const [, airline, number] = partialMatch;
      return `${airline}${number.padStart(4, "0")}/`;
    }

    return upperValue;
  };

  const isValidVuelo = (value) => {
    const regex = /^[A-Z]{2}\d{4}\/\d{2}[A-Z]{3}$/;
    return regex.test(value.toUpperCase());
  };

  const validateRows = () => {
    let sumaPiezas = 0;
    let sumaPeso = 0;

    const vuelosSet = new Set();

    const newErrors = rows.map((row, idx) => {
      const rowErrors = {};

      let flight_l = String(row.flight || "").trim();
      if (!flight_l) {
        rowErrors[0] = "El campo vuelo es obligatorio";
      } else if (!isValidVuelo(flight_l)) {
        rowErrors[0] = "Formato de vuelo incorrecto.";
      } else {
        const vueloFormateado = flight_l.toUpperCase();
        if (vuelosSet.has(vueloFormateado)) {
          rowErrors[0] = "El vuelo esta repetido";
        } else {
          vuelosSet.add(vueloFormateado);
        }
      }

      if (!row.time.trim()) rowErrors[4] = "El campo hora es obligatorio";

      let pieces_l = String(row.pieces || "").trim();
      if (!pieces_l) {
        rowErrors[1] = "El campo piezas es obligatorio";
      } else if (!isValidPiezas(pieces_l)) {
        rowErrors[1] = "Solo se permiten números enteros en el campo piezas";
      } else {
        sumaPiezas += parseInt(pieces_l);
      }

      let peso_l = String(row.weight || "").trim();

      if (!row.weight.trim()) {
        rowErrors[2] = "El campo peso es obligatorio";
      } else if (!isValidPeso(row.weight.trim())) {
        rowErrors[2] = "Máximo 4 decimales permitidos en el campo peso";
      } else {
        sumaPeso += parseFloat(row.weight);
      }

      return rowErrors;
    });

    //Validacion total al final
    if (sumaPiezas != totalPiezasGuia) {
      newErrors[3] = `El peso y piezas debe coincidir con los de la master. `;
    }

    if (sumaPeso != totalPesoGuia) {
      newErrors[3] = `El peso y piezas debe coincidir con los de la master. `;
    }
    setErrors(newErrors);
    return newErrors.every((rowErr) => Object.keys(rowErr).length === 0);
  };

  const handleInputChange = (index, field, value) => {
    const updatedRows = [...rows];

    if (field === "vuelo") {
      value = formatVuelo(value);
    }

    updatedRows[index][field] = value;
    setRows(updatedRows);

    // const updatedErrors = [...errors];
    // if (updatedErrors[index]?.[field] && value.trim() !== "") {
    //   updatedErrors[index][field] = "";
    //   setErrors(updatedErrors);
    // }
  };

  const handleAddRow = () => {
    const newRow = {
      vuelo: "",
      year: "2025",
      hora: "",
      piezas: "",
      peso: "",
    };
    const updatedRows = [...rows, newRow];
    setRows(updatedRows);

    let newAlerts = [...alerts];
    if (updatedRows.length === 2) {
      newAlerts.push("El peso y piezas debe coincidir con los de la master");
    } else if (updatedRows.length === 3) {
      newAlerts.push(
        "En caso de parcialidades, no se puede repetir los vuelos"
      );
    }

    setAlerts(newAlerts);
  };

  const handleDeleteRow = (index) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);

    let newAlerts = [...alerts];

    if (updatedRows.length < 3 && newAlerts.length > 1) {
      newAlerts.pop();
    }
    if (updatedRows.length < 2) {
      newAlerts = [];
    }

    setAlerts(newAlerts);
  };

  const handleSave = async () => {
    // Formatear todos los vuelos antes de validar
    const formattedRows = rows.map((row) => ({
      ...row,
      vuelo: formatVuelo(row.flight),
    }));

    setRows(formattedRows); // Actualizamos el estado con los valores corregidos

    const isValid = validateRows();
    if (!isValid) {
      const errorMessages = errors
        .map((e) => {
          if (typeof e === "string") return `• ${e}`;
          if (typeof e === "object" && e !== null) {
            return Object.values(e)
              .map((msg) => `• ${msg}`)
              .join("<br>");
          }
          return null;
        })
        .filter(Boolean)
        .join("<br>");

      Swal.fire({
        icon: "error",
        title: "Error",
        html: `<div style="text-align: left">${errorMessages}</div>`,
      });
      return;
    }

    const userData = localStorage.getItem("user");
    const user = JSON.parse(userData);
    const getUserId = () => {
      const user = JSON.parse(localStorage.getItem("user") || "null");
      return user?.id || "";
    };
    const postData = {
      time: Array.from(document.querySelectorAll(".time")).map(
        (el) => el.value
      ),
      pieces: Array.from(document.querySelectorAll(".pieces")).map(
        (el) => el.value
      ),
      weight: Array.from(document.querySelectorAll(".weight")).map(
        (el) => el.value
      ),
      year: Array.from(document.querySelectorAll(".year")).map(
        (el) => el.value
      ),
      flight: Array.from(document.querySelectorAll(".flight")).map(
        (el) => el.value
      ),
      awb: masterData.data.resp.id,
      user_id: getUserId(), //user.id,
    };

    const res = await axios.post(
      `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_assignation/saveReservation`,
      postData,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      }
    );

    if (res.data.code == 1) {
      confirmAlert();
    } else {
      Swal.fire("Error", "Master no encontrada, favor de verificar", "error");
    }

    // Reset
    // setRows([{ vuelo: "", year: "2025", hora: "", piezas: "", peso: "" }]);
    setErrors([]);
    setAlerts([]);
  };

  const confirmAlert = () => {
    Swal.fire({
      title: "Éxito",
      text: "Vuelo(s) reservado(s) con éxito",
      icon: "success",
      customClass: {
        confirmButton: "btn-ok",
        title: "alert-title",
        popup: "alert-bg",
      },
    });
  };

  const editarAlert = (houseId, house) => {
    let master = masterData.data.master;
    const currentYear = new Date().getFullYear();
    const yearOptions = Array.from(
      { length: currentYear - 2019 + 2 },
      (_, i) => 2019 + i
    );

    Swal.fire({
      title: "Asignación de vuelos",
      html: `
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-4 mb-3">
            <label class="form-label fw-bold text-start assignment-popup-label">House: ${house.hbs}</label>
          </div>
          <div class="col-md-4 mb-3">
            <label class="form-label fw-bold text-start assignment-popup-label">Piezas: ${house.pieces}</label>
          </div>
          <div class="col-md-4 mb-3">
            <label class="form-label fw-bold text-start assignment-popup-label">Peso: ${Number(house.gross_weight).toFixed(2)}</label>
          </div>
        </div>

        <div style="margin-top: 1rem; width: 100%;">
          <table id="dynamicTable" class="table fondo-headUPD text-center assignment-modal-table">
            <thead class="table-light">
              <tr>
                <th style="white-space: nowrap;">Vuelo</th>
                <th style="white-space: nowrap;">Año</th>
                <th style="white-space: nowrap;">Hora Vuelo</th>
                <th style="white-space: nowrap;">Piezas</th>
                <th style="white-space: nowrap;">Peso</th>
                <th style="white-space: nowrap;">Acciones</th>
              </tr>
            </thead>
            <tbody id="tableBody"></tbody>
          </table>
          <div id="validationError" class="text-danger mt-2 text-center" style="font-weight: bold;"></div>

          <div class="text-center">
            <button type="button" id="addRowBtn" class="btn btn-dark assignment-modal-add-btn">
              <span id="plusIcon"></span>
            </button>
          </div>
        </div>
      </div>
    `,
      showCancelButton: true,
      confirmButtonText: "Guardar",
      cancelButtonText: "Cancelar",
      preConfirm: async () => {
        // Aquí pones la función que quieres ejecutar al hacer clic en "Guardar"
        console.log('Guardar con houses');

        const tableBody = document.getElementById("tableBody");
        const errorDiv = document.getElementById("validationError");

        if (!tableBody || !errorDiv) return false;

        errorDiv.textContent = ""; // Limpia mensaje previo

        const filas = Array.from(tableBody.querySelectorAll("tr"));
        const datos = [];
        const vuelosSet = new Set();

        let totalPieces = 0;
        let totalWeight = 0;

        for (let i = 0; i < filas.length; i++) {
          const tr = filas[i];

          const flight = tr.querySelector("input.flight")?.value.trim();
          const year = tr.querySelector("select.year")?.value.trim();
          const time = tr.querySelector("input.time")?.value.trim();
          const pieces = tr.querySelector("input.pieces")?.value.trim();
          const weight = tr.querySelector("input.weight")?.value.trim();

          if (!flight || !year || !time || !pieces || !weight) {
            errorDiv.textContent = `Todos los campos son obligatorios.`;
            return false;
          }

          const flightKey = flight.replace(/\s+/g, "").toUpperCase();
          if (vuelosSet.has(flightKey)) {
            errorDiv.textContent = `El vuelo "${flight}" está duplicado.`;
            return false;
          }

          vuelosSet.add(flightKey);
          totalPieces += parseInt(pieces);
          totalWeight += parseFloat(weight);

          datos.push({ flight, year, time, pieces, weight });
        }

        // Validar totales contra house
        if (totalPieces !== parseInt(house.pieces)) {
          errorDiv.textContent = `La suma de piezas (${totalPieces}) no coincide con las piezas de la house (${house.pieces}).`;
          return false;
        }

        if (Math.abs(totalWeight - parseFloat(house.gross_weight)) > 0.01) {
          errorDiv.textContent = `La suma de pesos (${totalWeight.toFixed(2)}) no coincide con el peso de la house (${house.gross_weight}).`;
          return false;
        }

        const userData = localStorage.getItem("user");
        const user = JSON.parse(userData);
        const getUserId = () => {
          const user = JSON.parse(localStorage.getItem("user") || "null");
          return user?.id || "";
        };
        const postData = {
          time: datos.map((d) => d.time),
          pieces: datos.map((d) => d.pieces),
          weight: datos.map((d) => d.weight),
          year: datos.map((d) => d.year),
          flight: datos.map((d) => d.flight),
          awb: masterData.data.resp.id,
          user_id: getUserId(), //user.id,
          exp_house_id: house.id
        };
        const res = await axios.post(
          `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_assignation/saveReservation`,
          postData,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );

        if (res.data.code == 1) {
          Swal.fire("Éxito", "Datos guardados correctamente", "success").then(() => {
            onSuccess(master);
          });
        } else {
          Swal.fire("Error", "Master no encontrada, favor de verificar", "error");
        }

        return false;
      },
      customClass: {
        popup: "form-alert-popup",
        confirmButton: "btn-amc-blue",
        cancelButton: "btn-amc-pink",
        title: "alert-title assignment-popup-title",
      },
      didOpen: () => {
        // Renderizar ícono de plus
        const plusIcon = document.getElementById("plusIcon");
        if (plusIcon)
          createRoot(plusIcon).render(<FaPlus style={{ color: "white" }} />);

        const tableBody = document.getElementById("tableBody");
        const addRowBtn = document.getElementById("addRowBtn");

        const addRow = () => {
          const row = document.createElement("tr");
          const uid = `trash-${Date.now()}`;

          row.innerHTML = `
          <td><input type="text" class="form-control text-center flight assignment-modal-input" /></td>
          <td>
            <select class="form-select year assignment-modal-input">
              ${yearOptions
              .map(
                (y) =>
                  `<option value="${y}" ${y === currentYear ? "selected" : ""
                  }>${y}</option>`
              )
              .join("")}
            </select>
          </td>
          <td><input type="time" class="form-control text-center time assignment-modal-input" /></td>
          <td><input type="number" class="form-control text-center pieces assignment-modal-input" /></td>
          <td><input type="number" class="form-control text-center weight assignment-modal-input" step="0.01" /></td>
          <td>
            <button type="button" class="btn btn-white btn-sm deleteRowBtn">
              <span id="${uid}"></span>
            </button>
          </td>
        `;

          tableBody.appendChild(row);

          // Renderizar ícono de eliminar
          const trashIcon = document.getElementById(uid);
          if (trashIcon)
            createRoot(trashIcon).render(
              <FaTrashAlt style={{ color: "black" }} />
            );
          const inputFlight = row.querySelector("input.flight");
          inputFlight.addEventListener("change", (e) => {
            const formatted = formatFlight(e.target.value);
            e.target.value = formatted;
            // Si necesitas hacer más (como actualizar estado), llama aquí handleInputChange(index, "flight", formatted)
          });
          row.querySelector(".deleteRowBtn").addEventListener("click", () => {
            row.remove();
          });
        };

        addRowBtn.addEventListener("click", addRow);

        if (masterData?.data?.view_reser) {
          masterData.data.view_reser.forEach(res => {
            if (res.exp_house_id === houseId) {
              const row = document.createElement("tr");
              const uid = `trash-${Date.now()}-${Math.random()}`;
              let anio = parseFloat(res.year)
              row.innerHTML = `
                <td><input type="text" class="form-control text-center flight assignment-modal-input" value="${res.flight || ""}" /></td>
                <td>
                  <select class="form-select year assignment-modal-input">
                    ${yearOptions
                  .map(
                    (y) =>
                      `<option value="${y}" ${y === anio ? "selected" : ""
                      }>${y}</option>`
                  )
                  .join("")}
                  </select>
                </td>
                <td><input type="time" class="form-control text-center time assignment-modal-input" value="${res.time || ""}" /></td>
                <td><input type="number" class="form-control text-center pieces assignment-modal-input" value="${res.pieces || 1}" /></td>
                <td><input type="number" class="form-control text-center weight assignment-modal-input" step="0.01" value="${res.weight || 0}" /></td>
                <td>
                  <button type="button" class="btn btn-white btn-sm deleteRowBtn">
                    <span id="${uid}"></span>
                  </button>
                </td>
              `;

              tableBody.appendChild(row);

              // Renderizar ícono de eliminar
              const trashIcon = document.getElementById(uid);
              if (trashIcon)
                createRoot(trashIcon).render(
                  <FaTrashAlt style={{ color: "black" }} />
                );
              const inputFlight = row.querySelector("input.flight");
              inputFlight.addEventListener("change", (e) => {
                const formatted = formatFlight(e.target.value);
                e.target.value = formatted;
                // Si necesitas hacer más (como actualizar estado), llama aquí handleInputChange(index, "flight", formatted)
              });
              // Eliminar la fila
              row.querySelector(".deleteRowBtn").addEventListener("click", () => {
                row.remove();
              });
            }
          });
        }
      }
    });
  };

  useEffect(() => {
    validateRows();
    if (masterData.data.no_houses > 0) {
      setShowHouses(true);
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>Horus | Búsqueda master</title>
      </Helmet>
      <ScrollToTop />

      <div className="container-fluid assignment-text">
        <div className="row">
          <div className="col-12">
            <div className="row">
              {[
                { label: "Master", value: masterData.data.resp.awb },
                { label: "Origen", value: masterData.data.resp.orig },
                { label: "Destino", value: masterData.data.resp.dest },
                { label: "Piezas", value: masterData.data.resp.pieces },
                { label: "Peso", value: Number(masterData.data.resp.weight).toFixed(2) },
                { label: "Volúmen", value: masterData.data.resp.volume },
                {
                  label: "Tipo de mercancía",
                  value: masterData.data.resp.merch,
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className={`pb-3 pb-md-5 ${item.label === "Tipo de mercancía" ? "col-md-5" : "col-md-3"
                    }`}
                >
                  <span className="fw-bold">{item.label}: </span>
                  {item.value}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* tabla */}
        {!showHouses && (
          <div className="row mt-4">
            <div className="col-12">
              <table className="table assignment-main-table">
                <thead className="table-light fondo-head">
                  <tr>
                    <th>Vuelo</th>
                    <th>Año</th>
                    <th>Hora</th>
                    <th>Piezas</th>
                    <th>Peso</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          type="text"
                          className="form-control flight"
                          value={row.flight}
                          onChange={(e) => {
                            const formatted = formatFlight(e.target.value);
                            handleInputChange(index, "flight", formatted);
                          }}
                        />
                        {errors[index]?.flight && (
                          <div className="text-danger small">
                            {errors[index].flight}
                          </div>
                        )}
                      </td>
                      <td className="selectYear">
                        <select
                          id="inputYear"
                          class="form-select year"
                          value={row.year}
                          onChange={(e) =>
                            handleInputChange(index, "year", e.target.value)
                          }
                        >
                          {yearOptions.map((year) => (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td>
                        <input
                          type="time"
                          className="form-control time"
                          value={row.time}
                          onChange={(e) =>
                            handleInputChange(index, "time", e.target.value)
                          }
                        />
                        {errors[index]?.time && (
                          <div className="text-danger small">
                            {errors[index].time}
                          </div>
                        )}
                      </td>
                      <td>
                        <input
                          type="text"
                          className="form-control pieces"
                          min="0"
                          step="1"
                          value={row.pieces}
                          onChange={(e) =>
                            handleInputChange(index, "pieces", e.target.value)
                          }
                        />
                        {errors[index]?.pieces && (
                          <div className="text-danger small">
                            {errors[index].pieces}
                          </div>
                        )}
                      </td>
                      <td>
                        <input
                          type="text"
                          className="form-control weight"
                          min="0"
                          step="0.01"
                          value={row.weight}
                          onChange={(e) =>
                            handleInputChange(index, "weight", e.target.value)
                          }
                        />
                        {errors[index]?.weight && (
                          <div className="text-danger small">
                            {errors[index].weight}
                          </div>
                        )}
                      </td>
                      <td className="text-center">
                        {index > 0 && (
                          <button
                            className="btn"
                            onClick={() => handleDeleteRow(index)}
                          >
                            <FaTrashAlt />
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Alertas */}
              {alerts.map((alert, i) => (
                <div key={i} className="alert alert-warning text-center">
                  {alert}
                </div>
              ))}
            </div>
          </div>
        )}
        {!showHouses && (
          <div className="d-flex justify-content-center mt-4 gap-3">
            <button className="btn btn-amc-turq botonAdd" onClick={handleAddRow}>
              <FaPlus />
            </button>

            <button className="btnn" onClick={handleSave}>
              Guardar
            </button>
          </div>
        )}
        {showHouses && (
          <div className="row mb-4">
            <div className="col-12">
              <table
                className="table text-center mx-auto assignment-houses-table"
                style={{ maxWidth: "900px", width: "100%" }}
              >
                <thead className="table-light fondo-headUPD">
                  <tr>
                    <th>House</th>
                    <th>Piezas</th>
                    <th>Peso</th>
                    <th>Vuelos</th>
                  </tr>
                </thead>
                <tbody>
                  {masterData?.data?.houses.map((house, index) => (
                    <tr key={house.id}>
                      <td>{house.hbs}</td>
                      <td>{house.pieces}</td>
                      <td>{Number(house.gross_weight).toFixed(2)}</td>
                      <td>
                        <button
                          className="btn-pink-secondary custom-btn"
                          onClick={() => editarAlert(house.id, house)}
                          data-id-house={house.id}
                        >
                          <PiAirplaneTiltFill />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default AssignmentReservation;
